/* unplugin-vue-components disabled */import script from "./teacher.vue?vue&type=script&setup=true&lang=js"
export * from "./teacher.vue?vue&type=script&setup=true&lang=js"

import "./teacher.vue?vue&type=style&index=0&id=764f45f8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-764f45f8"]])

export default __exports__